<template>
  <div class="absensi-card" :class="{loading: isLoading}">
    <div class="absensi-header">
      <div class="absensi-date-row">
        <span class="absensi-date">Hari Ini ({{ currentDateStr }})</span>
        <oxd-icon name="file-edit" class="icon-edit" />
      </div>
      <div class="absensi-shift">
        Shift: Change Work Time 09:00-16:00 [09:00 - 16:00]
      </div>
    </div>

    <oxd-divider />

    <div class="absensi-times">
      <div class="absensi-time-block">
        <div class="time-user-circle">BA</div>
        <div class="time-details">
          <span class="time-label">Jam Masuk</span>
          <div class="time-value">
            <span class="time-text text-green">{{ startTime }}</span>
            <oxd-icon name="location" class="icon-status text-red" />
            <oxd-icon name="focus" class="icon-status text-red" />
          </div>
        </div>
      </div>
      <div class="time-divider"></div>
      <div class="absensi-time-block">
        <div class="time-user-circle">BA</div>
        <div class="time-details">
          <span class="time-label">Jam Keluar</span>
          <div class="time-value">
            <span class="time-text text-red">{{ endTime }}</span>
            <oxd-icon name="location" class="icon-status text-red" />
            <oxd-icon name="focus" class="icon-status text-red" />
          </div>
        </div>
      </div>
    </div>

    <div class="absensi-action">
      <oxd-button
        class="btn-rekam-waktu"
        display-type="secondary"
        label="Rekam Waktu"
        @click="onClickPunchIn"
      />
    </div>

    <div v-if="showDetail" class="absensi-detail-wrapper">
      <div class="absensi-istirahat">
        <span class="istirahat-label">Waktu Istirahat 1:</span>
        <span class="istirahat-value">--:-- - --:--</span>
      </div>

      <div class="absensi-lainnya">
        <a href="#">Lainnya</a>
      </div>
    </div>

    <oxd-divider />

    <div class="absensi-footer" @click="toggleDetail">
      {{ showDetail ? 'Sembunyikan Detail' : 'Tampilkan Detail' }}
      <oxd-icon :name="showDetail ? 'chevron-up' : 'chevron-down'" />
    </div>
  </div>
</template>

<script>
import {navigate} from '@/core/util/helper/navigation';
import {freshDate, formatDate} from '@/core/util/helper/datefns';
import {OxdIcon, OxdButton, OxdDivider, OxdText} from '@ohrm/oxd';

export default {
  name: 'EmployeeAbsensiWidget',
  components: {
    'oxd-icon': OxdIcon,
    'oxd-button': OxdButton,
    'oxd-divider': OxdDivider,
  },
  data() {
    return {
      isLoading: false,
      startTime: '--:--',
      endTime: '--:--',
      showDetail: true,
      currentDateStr: '',
    };
  },
  beforeMount() {
    const d = freshDate();
    this.currentDateStr = formatDate(d, 'EEE, dd MMM yyyy'); // e.g., Rab, 10 Jun 2026
  },
  methods: {
    onClickPunchIn() {
      navigate('/attendance/punchIn');
    },
    toggleDetail() {
      this.showDetail = !this.showDetail;
    },
  },
};
</script>
<style src="./employee-absensi-widget.scss" lang="scss" scoped></style>
